export default {

  required: {
    message : "File is required!",
    fn      : (input)=> input?.name,
  },

}
